<div class="paginator" >
  <div class="col">
    <div class="sections">
      <div class="section">
        <div class="label">
          <ng-content select="items-per-page-amount"></ng-content>
        </div>
      </div>
      <div class="section" #perPageTarget>
        <div class="combowrap">
          <button
            class="action action--per-page"
            (click)="togglePerPageAmountDropdown()"
            [intAttrBinding]="{
              attr: testingMarkers.mark,
              value: testAttrsValues.perPageActionMarker
            }"
          >
            <span class="action__content a-mr">
              {{perPage}}
            </span>
            <span class="action__icon">
              <int-icon name="chevron" size="0.9rem"></int-icon>
            </span>
          </button>
          <ng-container *intInsertAfterViewInit>
            <int-portal-slot
              [show]="(isShowPerPageDropdown$ | async)"
              [targetRef]="perPageTarget">
              <ng-template intPortalSlotTemplate>
                <int-dropdown-area
                  (clickOutside)="closePerPageDropdown()"
                  class="_drop"
                  [excludeElementsForClickOutside]="perPageTarget"
                >
                  <div>
                    <ul class="dropdown-list" *ngIf="perPageList.length">
                      <li
                        class="dropdown-item"
                        [class.dropdown-item--active]="perPage === amount"
                        *ngFor="let amount of perPageList"
                        (click)="changePerPageAmount(amount)"
                        [intAttrBinding]="{
                          attr: testingMarkers.mark,
                          value: testAttrsValues.perPageListItemMarker
                        }"
                      >
                        {{ amount }}
                      </li>
                    </ul>
                  </div>
                </int-dropdown-area>
              </ng-template>
            </int-portal-slot>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
  <int-empty-divider size="1rem"></int-empty-divider>
  <div class="col">
    <div class="sections" *ngIf="isPossibleToShow">
      <div class="section" *ngIf="isNotFirstPage">
        <button
          class="action"
          (click)="goToPreviousPage()"
          [intAttrBinding]="{
            attr: testingMarkers.mark,
            value: testAttrsValues.prevPageAction
          }"
        >
          <int-icon name="chevron-left" size="1.2rem"></int-icon>
        </button>
      </div>
      <div class="section" #pagesAmountTarget>
        <button
          class="action action--per-page"
          (click)="togglePageDropdown()"
        >
          <span
            class="action__content a-mr"
            [intAttrBinding]="{
              attr: testingMarkers.mark,
              value: testAttrsValues.pageSelectorAction
            }"
          >
            {{currentPage}}
          </span>
          <span class="action__icon">
            <int-icon name="chevron" size="0.9rem"></int-icon>
          </span>
        </button>
        <ng-container *intInsertAfterViewInit>
          <int-portal-slot
            [show]="(isShowPageAmountDropdown$ | async)"
            [targetRef]="pagesAmountTarget">
            <ng-template intPortalSlotTemplate>
              <int-dropdown-area
                (clickOutside)="closePageAmount()"
                class="_drop"
                [excludeElementsForClickOutside]="pagesAmountTarget"
              >
                <cdk-virtual-scroll-viewport class="cdk-viewport" [itemSize]="10">
                  <ul  class="dropdown-list" *ngIf="pagesAmount">
                    <li class="dropdown-item"
                      *cdkVirtualFor="let amount of pagesAmountList"
                      (click)="togglePageEvent(amount)"
                      [class.dropdown-item--active]="currentPage === amount"
                    >
                    <span
                      [intAttrBinding]="{
                        attr: testingMarkers.mark,
                        value: testAttrsValues.pageSelectorListItem
                      }"
                    >{{ amount }}</span>
                    </li>
                  </ul>
                </cdk-virtual-scroll-viewport>
              </int-dropdown-area>
            </ng-template>
          </int-portal-slot>
        </ng-container>
      </div>
      <div class="section">
        <int-target-dropdown
          [positions]="['top']"
          [dropdownWidth]="250"
          (dropVisibleStatusEvent)="setDropVisibleStatus($event)"
          [dropAreaStyles]="{
            '--int-dropdown-area-bg-color': 'var(--int-default-paginator-search-drop-bg-color)'
          }"
        >
          <ng-container ngProjectAs="target">
            <div class="label curp">
              <ng-content select="pages-amount"></ng-content>
            </div>
          </ng-container>
          <ng-container ngProjectAs="content">
            <int-default-input
              [formControl]="control"
              label="№"
            >
              <ng-container ngProjectAs="right-position">
                <button int-button size="sm" *ngIf="isSearchValid" (click)="searchPage()">
                  <int-icon name="search" size="1rem"></int-icon>
                </button>
              </ng-container>
            </int-default-input>
          </ng-container>
        </int-target-dropdown>

      </div>
      <div class="section" *ngIf="isNotLastPage">
        <button
          class="action"
          (click)="goToNextPage()"
          [intAttrBinding]="{
            attr: testingMarkers.mark,
            value: testAttrsValues.nextPageAction
          }"
        >
          <int-icon name="chevron-right" size="1.2rem"></int-icon>
        </button>
      </div>
    </div>
  </div>
</div>
